import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from 'src/app/configration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class ApiImportService {

  environment: any;
  deadlinesEnpoint: string;

  constructor(
    private http: HttpClient,
    private configurationservice: ConfigurationService
  ) {
    this.environment = this.configurationservice.getEnvironmentVariables();
    this.deadlinesEnpoint = `${this.environment.musterkundeDevEndpoint}/api/Deadlines`;
   }

  getMonthUltimos() {
    const url = `${this.deadlinesEnpoint}/GetMonthUltimos`;
    return this.http.get(url);
  }

  getApiImportDeadline() {
    const url = `${this.deadlinesEnpoint}/GetMonthUltimos`;
    return this.http.get(url);
  }

  createApiImportDeadline(data: any) {
    console.log(data);
    const url = `${this.deadlinesEnpoint}/CreateApiImportDeadline`;
    return this.http.post(url, data);

  }

  getApiImportSubscrition() {
    const url = `${this.deadlinesEnpoint}/GetApiImportSubscription`;
    return this.http.get(url);

  }

  setApiImportSubscrition(data: any) {
    const url = `${this.deadlinesEnpoint}/SetApiImportSubscription`;
    return this.http.post(url, data);

  }

}
